var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('iframe',{style:({ width: '100%', height: '100%' }),attrs:{"src":"/GoogleLogin.html","frameborder":"0","allow":"identity-credentials-get"}}),_c('Bug')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }